module.exports = __webpack_public_path__ + "fcc41c9ccbc267b9b7fb3a4a8487570e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/logos/nordddb-logo-1.svg
// module id = HCgM
// module chunks = 8